import { Activity } from 'lucide-react';
import { lazy } from 'react';

import { apiUsageTranslations as enApiUsage } from '@/lang/en/apiUsage';
import { apiUsageTranslations as esApiUsage } from '@/lang/es/apiUsage';
import { apiUsageTranslations as ptApiUsage } from '@/lang/pt/apiUsage';
import { label, type FeatureModule } from '@/platform/app/contracts';
import { namespaceBundle } from '@/platform/i18n/types';

const ApiUsageSection = lazy(() =>
  import('./presentation/components/ApiUsageSection').then((m) => ({
    default: m.ApiUsageSection,
  })),
);

/** API usage metrics (settings section). */
export const apiUsageModule: FeatureModule = {
  id: 'api-usage',
  settingsSections: [
    {
      id: 'apiUsage',
      group: 'developers',
      order: 20,
      label: label('settings', 'nav_api_usage'),
      icon: Activity,
      Component: ApiUsageSection,
    },
  ],
  i18n: namespaceBundle('apiUsage', { es: esApiUsage, en: enApiUsage, pt: ptApiUsage }),
};
